import DatosPersonales from './DatosPersonales';

export default DatosPersonales;
